import Http from '@/support/http';

import toastr from '@/support/toastr';

export default {
	getLeavingMonitor(context, payload) {

		if (payload) {

			return Http.get(`v1/get-at-school/user/${payload}?schoolClassId=`).then((response) => {

				response.data.forEach((value) => {

					if (!value.student.photoURL) {
						value.student.photoURL = 'assets/images/default-avatar.png';
					}
				});

				context.commit('SET_LEAVING_MONITOR', response.data);

				return response;

			});

		}
	}, postStudentRelease(context, payload) {

		const route = `/v1/get-at-school/${payload.id}/user/1`;

		return Http.post(route, payload).then((response) => {

			toastr.success('Aluno liberado com sucesso!');

			return response;

		});
	}
};



// WEBPACK FOOTER //
// ./sources/app/leaving-monitor/actions.js